import React from 'react'

function Footer(){
  return (
    <>
    <div className='footer'>
    <h4 className='card-h4'>DESIGNED AND DEVELOPED BY </h4>
        <h2>Rudra Karmakar</h2>
        
        <h4 className='card-h4'>© 2026 All rights reserved by Rudra Karmakar.</h4>
    </div>
    </>
  );
}
export default Footer;